import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials is required so the browser sends the httpOnly `cmp_admin_session`
// cookie set by the backend on admin login. No admin token is ever stored in localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
